import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "@/hooks/use-auth"

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { state, memberships } = useAuth()
  const location = useLocation()
  if (state === "loading") return <CenteredSpinner />
  if (state === "anonymous") {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?redirect=${redirect}`} replace />
  }
  if (memberships.length === 0 && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />
  }
  return <>{children}</>
}

export function RequireAnon({ children }: { children: React.ReactNode }) {
  const { state } = useAuth()
  if (state === "loading") return <CenteredSpinner />
  if (state === "authenticated") return <Navigate to="/dashboard" replace />
  return <>{children}</>
}

export function RequireSuperuser({ children }: { children: React.ReactNode }) {
  const { state, user } = useAuth()
  const location = useLocation()
  if (state === "loading") return <CenteredSpinner />
  if (state === "anonymous") {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?redirect=${redirect}`} replace />
  }
  if (!user?.is_superuser) return <Navigate to="/dashboard" replace />
  return <>{children}</>
}

function CenteredSpinner() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-muted border-t-foreground" />
    </div>
  )
}
